"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachSandPebble = function SvgBeachSandPebble(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 34",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.113 7.902c.055-3.565 4.724-5.905 4.724-5.905s4.557 2.16 6.17 7.47c.536 1.763.368 3.674-.297 5.43m-8.358 6.253c-5.493-.29-8.401-4.751-8.748-6.935-.346-2.184 1.667-5.49 5.008-6.28 3.34-.791 6.304 3.46 4.275 6.32-2.03 2.861-4.827 1.065-4.96-.48-.133-1.544 1.847-3.555 2.888-2.545 1.041 1.01.367 2.519-.859 2.229",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.829 8.396s1.138-3.806 4.54-5.115m-3.363 6.632s2.678-4.098 7.162-2.288m-6.526 4.502s4.224-1.47 7.089 2.331m-7.642-.098s2.356.752 3.685 3.546m-6.032-2.104s1.71 2.731-.304 4.814m-1.56-5.167s-.8 2.432-3.188 2.402m2.018-4.394s-1.968.888-3.596-1.775m3.955-3.663s-1.092 1.926.81 3.221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.063 22.43c-1.612-.901-3.01-1.856-2.335-3.026.676-1.17 2.843-.454 4.19.629 1.346 1.082 3.231 2.517 2.792 3.279-.44.76-2.768.17-4.647-.881zm-10.285 2.412c1.846-.072 3.525-.287 3.454-1.636-.07-1.35-2.327-1.695-4.018-1.342-1.69.353-3.938 0-3.976 1.654-.038 1.653 2.388 1.408 4.54 1.324z",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.847 13.626c-.542-.107-2.949-.604-3.432 1.672-.484 2.277 3.08 2.674 3.08 2.674s4.79.842 5.19-1.036c.399-1.878-3.642-3.073-4.838-3.31z",
    stroke: "#17181A",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.112 14.764c-.08-.179-.81-1.856-.893-2.039C33.247 8.345 31.017 3 28.861 3c-2.567 0-4.666 5.703-4.666 5.703L21 14.763m6 4.012S23.829 15 20.436 15c-3.393 0-2.936 3.775-5.602 5.46-2.666 1.685-4.455 0-5.834 4.617",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17181A",
    transform: "matrix(-1 0 0 1 57.132 0)",
    cx: 28.566,
    cy: 10.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17181A",
    transform: "matrix(-1 0 0 1 43.132 0)",
    cx: 21.566,
    cy: 19.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17181A",
    transform: "matrix(-1 0 0 1 55.132 0)",
    cx: 27.566,
    cy: 24.566,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.478 17.98c1.9.265 3.1.961 3.6 2.087.752 1.689 2.631 2.593 4.8 1.863 2.17-.73 6.421.122 8.38 3.416m-12.229-7.881 1.983 4.668",
    stroke: "#17181A"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgBeachSandPebble);
var _default = Memo;
exports["default"] = _default;